import * as types from '../constants';

export const setOpenableModalConfig = (isOpen) => ({
  type: types.SET_OPENABLE_MODAL_CONFIG,
  payload: isOpen,
});